export const getEnvironmentVar = (name) => process.env[name] || window.__RUNTIME_ENV[name];
